import React from 'react';
import { ActiveIntegrationsGrid } from '../components/ActiveIntegrationsGrid';
import { FutureIntegrationsList } from '../components/FutureIntegrationsList';

const IntegrationsPage: React.FC = () => {
    return (
        <div className="min-h-screen bg-gray-50/50 p-6 md:p-8">
            <div className="mx-auto max-w-7xl space-y-10">
                {/* Header */}
                <div className="flex flex-col md:flex-row md:justify-between md:items-end gap-4 mb-4">
                    <div>
                        <h1 className="text-4xl font-bold text-slate-900 mb-2 tracking-tight">Integraciones</h1>
                        <p className="text-slate-500 text-lg">
                            Conectá y administrá las fuentes de datos que usa Deenex AI para ejecutar campañas inteligentes.
                        </p>
                    </div>
                </div>

                {/* Active Integrations */}
                <ActiveIntegrationsGrid />

                {/* Future Integrations */}
                <FutureIntegrationsList />
            </div>
        </div>
    );
};

export default IntegrationsPage;
